import React, { Component } from 'react';
import Styled from './styles';
import api from '../../lib/api';
import ButtonBase from '@material-ui/core/ButtonBase';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PhoneIcon from '../../icons/phone-icon';
import CopyIcon from '../../icons/copy-icon';
import copy from '../../utils/copyToClipboard';
import capitalize from '../../utils/capitalize';

const styles = theme => ({
  container: {
    paddingBottom: 10,
    position: 'relative',
    height: 380,
    overflow: 'scroll'
  },
  phoneIcon: { width: 29, height: 29, marginRight: 10 },
  phoneNumberLabel: {
    textAlign: 'center',
    color: '#a6a6a6',
    fontWeight: 'bold',
    paddingTop: 10,
    paddingBottom: 10
  },
  phoneNumberButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 15px'
  },
  phoneNumberButton: { padding: '10px 20px' },
  phoneNumberText: { fontSize: 25, color: '#a6a6a6' },
  leadsDataItem: {
    width: '100%',
    textAlign: 'left',
    justifyContent: 'flex-start'
  },
  leadsDataItemLabel: {
    color: '#a6a6a6',
    fontWeight: 'bold',
    textTransform: 'capitalize'
  },
  leadsDataItemValue: { fontSize: 17 },
  copyIconButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: 30,
    width: 30
  },
  copyIcon: { height: 17, width: 17 }
});

class SecureLeads extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      uuid: this.props.match.params.uuid,
      leadsData: null,
      error: null,
      loading: false,
      isSnackbarOpen: false,
      snackbarMessage: ''
    };
  }

  onCopy = () => {
    const { leadsData } = this.state;
    if (leadsData) {
      let formattedData = `Phone: ${leadsData.phoneNumber} \n`;

      formattedData += Object.keys(leadsData)
        .filter(key => key !== 'phoneNumber')
        .map(key => `${key}: ${leadsData[key]}`)
        .join('\n');

      copy(formattedData);

      this.setState({
        isSnackbarOpen: true,
        snackbarMessage: `Lead details are copied`
      });
    }
  };

  handlePhoneNumberClick = () => {
    const { leadsData } = this.state;
    if (leadsData) {
      copy(leadsData.phoneNumber);
      this.setState({
        isSnackbarOpen: true,
        snackbarMessage: `Phone Number is copied`
      });
      window.location.href = `tel:${leadsData.phoneNumber}`;
    }
  };

  handleItemClick = key => {
    const { leadsData } = this.state;
    if (leadsData) {
      copy(leadsData[key]);
      this.setState({
        isSnackbarOpen: true,
        snackbarMessage: `${capitalize(key)} is copied`
      });
    }
  };

  onSnackbarClose = () => {
    this.setState({ isSnackbarOpen: false, snackbarMessage: '' });
  };

  componentDidMount() {
    this.setState({ loading: true });
    api
      .getSecureLead(this.state.uuid)
      .then(data => {
        this.setState({
          leadsData: data,
          error: null,
          loading: false
        });
      })
      .catch(err => {
        this.setState({ error: 'Something went wrong', loading: false });
      });
  }

  render() {
    const {
      leadsData,
      error,
      loading,
      isSnackbarOpen,
      snackbarMessage
    } = this.state;

    const { classes } = this.props;

    if (loading) {
      return (
        <Styled.CenteredBox>
          <CircularProgress size={20} thickness={5} color="primary" />
        </Styled.CenteredBox>
      );
    }

    if (error) {
      return (
        <Styled.CenteredBox>
          <Styled.Box>
            <p>{error}</p>
          </Styled.Box>
        </Styled.CenteredBox>
      );
    }

    if (!leadsData) return null;

    return (
      <Styled.CenteredBox>
        <Paper classes={{ root: classes.container }}>
          <Styled.PhoneNumberContainer style={{ marginBottom: 20 }}>
            <Typography classes={{ root: classes.phoneNumberLabel }}>
              Phone Number
            </Typography>
            <Paper classes={{ root: classes.phoneNumberButtonContainer }}>
              <ButtonBase
                classes={{ root: classes.phoneNumberButton }}
                onClick={this.handlePhoneNumberClick}
              >
                <PhoneIcon className={classes.phoneIcon} />
                <Typography classes={{ root: classes.phoneNumberText }}>
                  {leadsData.phoneNumber}
                </Typography>
              </ButtonBase>
            </Paper>
          </Styled.PhoneNumberContainer>
          <Divider />
          {Object.keys(leadsData)
            .filter(key => key !== 'phoneNumber')
            .map(key => (
              <React.Fragment key={key}>
                <ButtonBase
                  classes={{ root: classes.leadsDataItem }}
                  onClick={() => this.handleItemClick(key)}
                >
                  <Styled.LeadsDataItem>
                    <Typography classes={{ root: classes.leadsDataItemLabel }}>
                      {key}
                    </Typography>
                    <Typography classes={{ root: classes.leadsDataItemValue }}>
                      {leadsData[key]}
                    </Typography>
                  </Styled.LeadsDataItem>
                </ButtonBase>
                <Divider />
              </React.Fragment>
            ))}
          <IconButton
            classes={{ root: classes.copyIconButton }}
            onClick={this.onCopy}
          >
            <CopyIcon className={classes.copyIcon} />
          </IconButton>
        </Paper>
        <Snackbar
          open={isSnackbarOpen}
          message={snackbarMessage}
          autoHideDuration={4000}
          onClose={this.onSnackbarClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        />
      </Styled.CenteredBox>
    );
  }
}

export default withStyles(styles)(SecureLeads);



// WEBPACK FOOTER //
// ./src/pages/SecureLeads/index.js